import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Spinner } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";
import "./ViewPage.css";

const ViewCustomer = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (id) {
      fetchCustomerDetails();
    }
  }, [id]);

  const fetchCustomerDetails = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await api.post("/customer_detail.php", { id });
      
      if (response.data.head.code === 200) {
        const customerData = response.data.body;
        const transformedCustomer = {
          id: customerData.id,
          name: customerData.name,
          phoneNo: customerData.mobile,
          address: customerData.address,
          city: customerData.city,
          state: customerData.state,
          pin_code: customerData.pin_code,
          gstNo: customerData.gst_no
        };
        setCustomer(transformedCustomer);
      } else {
        setError(response.data.head.msg || "Customer not found");
      }
    } catch (err) {
      console.error("Error fetching customer details:", err);
      setError("Failed to load customer details. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleRetry = () => {
    fetchCustomerDetails();
  };

  if (loading) {
    return (
      <Container fluid className="outer-container my-4">
        <h2 className="text-center mb-3">Customer Details</h2>
        <Row>
          <Col>
            <div className="text-center py-5">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
              <p className="mt-3">Loading customer details...</p>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  if (error || !customer) {
    return (
      <Container fluid className="outer-container my-4">
        <h2 className="text-center mb-3">Customer Details</h2>
        <Row>
          <Col>
            <div className="not-found-box">
              <p className="mb-3">{error || "Customer not found."}</p>
              <div className="d-flex justify-content-center gap-3">
                <Button variant="secondary" onClick={() => navigate(-1)}>
                  Back
                </Button>
                <Button variant="primary" onClick={handleRetry}>
                  Retry
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container fluid className="outer-container my-4">
      <h2 className="text-center mb-3">Customer Details</h2>
       
      <div className="customer-header d-flex justify-content-end align-items-center mb-3">
        <Button className="btn-top" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>

      <div className="customer-view-wrapper">
        <div className="customer-view-card">
          <div className="customer-details-table-wrapper">
            <table className="customer-view-table" role="table" aria-label={`Details for ${customer.name}`}>
              <tbody>
                <tr>
                  <td className="field-cell">Customer Name</td>
                  <td className="value-cell">{customer.name}</td>
                </tr>

                <tr>
                  <td className="field-cell">Phone Number</td>
                  <td className="value-cell">{customer.phoneNo || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">Address</td>
                  <td className="value-cell">{customer.address || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">City</td>
                  <td className="value-cell">{customer.city || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">State</td>
                  <td className="value-cell">{customer.state || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">Pin Code</td>
                  <td className="value-cell">{customer.pin_code || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">GST Number</td>
                  <td className="value-cell">{customer.gstNo || "-"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ViewCustomer;